import type {ReactNode} from 'react';

import {type Inline, parseMrkdwn} from '../mrkdwn';

const Run = ({run}: {run: Inline}) => {
    let node: ReactNode = run.code ? <code>{run.text}</code> : run.text;
    if (run.strike) node = <s>{node}</s>;
    if (run.italic) node = <em>{node}</em>;
    if (run.bold) node = <strong>{node}</strong>;
    return node;
};

/** A Slack message's formatting as elements, never as HTML, so a message cannot inject markup. */
export const SlackText = ({text, className}: {text: string; className?: string}) => (
    <span className={className ? `bt-md ${className}` : 'bt-md'}>
        {parseMrkdwn(text).map((block, i) =>
            block.kind === 'code' ? (
                // biome-ignore lint/suspicious/noArrayIndexKey: blocks are positional and never reorder
                <code key={i} className="bt-md__code">
                    {block.text}
                </code>
            ) : (
                // biome-ignore lint/suspicious/noArrayIndexKey: blocks are positional and never reorder
                <span key={i} className={`bt-md__${block.kind}`}>
                    {block.inlines.map((run, j) => (
                        // biome-ignore lint/suspicious/noArrayIndexKey: runs are positional and never reorder
                        <Run key={j} run={run} />
                    ))}
                </span>
            ),
        )}
    </span>
);
